import i18n from '@/i18n/i18n'

export const SETTINGS_RATES_ROUTE = 'rates'
export const SETTINGS_PRICE_CALCULATOR_ROUTE = 'calculator'
export const SETTINGS_PRICES_LIST_ROUTE = 'price-list'

export default {
  name: SETTINGS_RATES_ROUTE,
  path: 'rates',

  component: () => import('@/app/settings/rates/views/RatesNav.vue'),
  redirect: () => {
    return { name: SETTINGS_PRICES_LIST_ROUTE }
  },
  children: [
    {
      name: SETTINGS_PRICES_LIST_ROUTE,
      path: 'price-list',
      component: () => import('@/app/settings/rates/price-list/views/PriceList.vue'),
      meta: {
        pageTitle: () => i18n.t('Price list'),
        permissions: ['view_prices'],
      },
    },
    {
      name: SETTINGS_PRICE_CALCULATOR_ROUTE,
      path: 'calculator',
      redirect: () => {
        return { name: SETTINGS_PRICES_LIST_ROUTE }
      },
      meta: {
        pageTitle: () => i18n.t('Price calculator'),
        permissions: ['view_prices'],
      },
    },
  ],
}
